module.exports = {
	"id": "IS",
	"name": "Iceland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.007076,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.007076,
			"30": 0.014152,
			"31": 0.021228,
			"32": null,
			"33": 0.007076,
			"34": 0.049532,
			"35": null,
			"36": 0.007076,
			"37": 0.021228,
			"38": 0.028304,
			"39": 0.042456,
			"40": 0.014152,
			"41": 0.028304,
			"42": 0.03538,
			"43": 0.056608,
			"44": 0.134444,
			"45": 0.028304,
			"46": 0.042456,
			"47": 0.063684,
			"48": 0.120292,
			"49": 1.83976,
			"50": 0.198128,
			"51": 0.650992,
			"52": 0.7076,
			"53": 33.108604,
			"54": 7.833132,
			"55": 0.091988,
			"56": 0.021228,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.014152,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.014152,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.021228,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.113216,
			"36": null,
			"37": 0.007076,
			"38": 0.03538,
			"39": 0.021228,
			"40": 0.014152,
			"41": 0.091988,
			"42": 0.021228,
			"43": 0.198128,
			"44": 0.014152,
			"45": 0.091988,
			"46": 0.091988,
			"47": 0.332572,
			"48": 0.45994,
			"49": 6.58068,
			"50": 0.07076,
			"51": 0.021228,
			"52": null,
			"3.5": null,
			"3.6": 0.014152
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.007076,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.007076,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.007076,
			"36": 0.021228,
			"37": 0.014152,
			"38": 0.084912,
			"39": 0.014152,
			"40": 0.42456,
			"41": 0.049532,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.148596
		},
		"safari": {
			"0": null,
			"4": 0.014152,
			"5": 0.063684,
			"6": 0.014152,
			"7": 0.07076,
			"8": 0.417484,
			"9": 0.49532,
			"10": 2.58274,
			"3.1": null,
			"3.2": null,
			"5.1": 0.127368,
			"6.1": 0.162748,
			"7.1": 0.014152,
			"9.1": 2.26432
		},
		"ios_saf": {
			"8": 0,
			"10": 8.31431895337,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.224061275083,
			"8.1-8.4": 0.413943711595,
			"9.0-9.2": 0.197477733972,
			"9.3": 3.01280132598
		},
		"android": {
			"3": 0,
			"4": 0.00787774935401,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.000984718669251,
			"4.1": 0.0284161673127,
			"4.2-4.3": 0.0710404182817,
			"4.4": 0.162900602713,
			"4.4.3-4.4.4": 0.164307343669
		},
		"ie": {
			"6": null,
			"7": 0.00712672401434,
			"8": 0.135407756272,
			"9": 0.0783939641577,
			"10": 0.0783939641577,
			"11": 3.6773895914,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0122962465331,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000341562403698
		},
		"edge": {
			"12": 0.084912,
			"13": 0.551928,
			"14": 1.988356
		},
		"ie_mob": {
			"10": 0.0541784225352,
			"11": 0.220583577465
		},
		"bb": {
			"7": 0.00365375,
			"10": null
		},
		"samsung": {
			"0": 3.525138
		},
		"and_uc": {
			"0": 0.040922
		},
		"op_mini": {
			"0": 0.165665191063
		},
		"and_chr": {
			"0": 12.973434
		},
		"and_ff": {
			"0": 0.02923
		}
	},
	"total": 96.64036875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IS.json
 ** module id = 554
 ** module chunks = 0
 **/